export default __webpack_public_path__ + "static/media/sorry.1fc0e83a.png";